export const ALL_BADGES = {
  upbo2uZiviPEpFGfnFnT: {
    id: 'upbo2uZiviPEpFGfnFnT',
    image:
      'https://storage.googleapis.com/sayido-assets-production/badges/badge-as-seen_046d2291-0a8d-46df-a87e-a8531b926ed5.png',
    alt: 'As Seen on Say I do',
  },
  uxlz0lyinZc2doKQdSn6: {
    id: 'uxlz0lyinZc2doKQdSn6',
    image:
      'https://storage.googleapis.com/sayido-assets-production/badges/badge-featured_c1ed40a6-3986-4f3f-8aec-ed4bb7d961a4.png',
    alt: 'Featured on Say I do',
  },
  n9UHQ3oEEkJigZI8KIv1: {
    id: 'n9UHQ3oEEkJigZI8KIv1',
    image:
      'https://storage.googleapis.com/sayido-assets-production/badges/badge-best-of-2021_37c7efb6-9b0e-4050-85d6-eb2e70f0d733.png',
    alt: 'Say I do Best of Weddings 2021',
  },
  NikYsfFvzuXUbbuiz27I: {
    id: 'NikYsfFvzuXUbbuiz27I',
    image:
      'https://storage.googleapis.com/sayido-assets-production/badges/badge-excellence-2021_7354e690-1801-46ae-ac53-df58b90a3f08.png',
    alt: 'Say I do Wedding Excellence 2021',
  },
  SgMHUWkHFPvfxpcMybMA: {
    id: 'SgMHUWkHFPvfxpcMybMA',
    image:
      'https://storage.googleapis.com/sayido-assets-production/badges/badge-best-of-2022_463dbe43-98bd-487c-b794-f54b2c2d4829.png',
    alt: 'Say I do Best of Weddings 2022',
  },
  kj6uWJaVNX1rGR19VCPO: {
    id: 'kj6uWJaVNX1rGR19VCPO',
    image:
      'https://storage.googleapis.com/sayido-assets-production/badges/badge-excellence-2022_eeebca9c-4675-4989-abc7-576ebc14a2c3.png',
    alt: 'Say I do Wedding Excellence 2022',
  },
};
